<template>
	<div>
		<div class="top">
			<el-row :gutter="10">
			  <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6"><div class="grid-content welcome" style="text-align: right;">
				<span v-if="!isLogin">你好，欢迎访问海润龙物流运输采招网！</span>
			  </div>
			  </el-col>
			  <el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12">
				  <div class="grid-content welcome" style="text-align: left;" v-if="isLogin">
					  你好，<span style="color:#409EFF">{{userInfo.username}}</span>，欢迎访问海润龙物流运输采招网！
					  <el-button type="text" style="color:#409EFF" @click="handle('/usercenter')">会员中心</el-button> | <el-button type="text" style="color:#409EFF" @click="loginOut">退出</el-button>  </div>
				  <div class="grid-content form" v-if="!isLogin">
				  <el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item style="width:15%">
						<el-input v-model="formInline.username" placeholder="请输入账号" size="mini"></el-input>
					</el-form-item>
					<el-form-item style="width:15%">
						<el-input type="password" v-model="formInline.password" placeholder="请输入密码" size="mini"></el-input>
					</el-form-item>
<!-- 					<el-form-item style="width:10%">
						<el-input v-model="formInline.user" placeholder="验证码" size="mini"></el-input>
					</el-form-item>
					<el-form-item style="height: 35px;">
						<img src="http://43.138.172.5:999/captcha.html" width="100" height="25" style="vertical-align: middle;" onclick="this.src = '/captcha.html?r=' + Math.random();">
					</el-form-item> -->
					<el-form-item>
					  <el-button type="primary" size="mini" @click="onSubmit('formInline')">登录</el-button>
					</el-form-item>
					<el-form-item>
					  <el-button type="info " size="mini" @click="handle('/register')">注册</el-button>
					</el-form-item>
				  </el-form>
			  </div>
			  </el-col>
			  <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6" style="text-align: left;">
				<div class="grid-content">
				  <el-row :gutter="0">
					<el-col :span="4"><div class="grid-content topright"><a href="javascript:;" class="toprightfirst">桌面图标</a></div></el-col>
					<el-col :span="4"><div class="grid-content topright"><a href="javascript:;">加入收藏</a></div></el-col>
					<el-col :span="4"><div class="grid-content topright" @click="handle('/about/wzsm')"><a href="javascript:;">网站声明</a></div></el-col>
					<el-col :span="4"><div class="grid-content topright" @click="handle('/about')"><a href="javascript:;">关于我们</a></div></el-col>
				  </el-row>
			  </div>
			</el-col>
			</el-row>
		</div>
		<div class="middle">
			<el-row :gutter="10">
				<el-col :xs="0" :sm="8" :md="8" :lg="8" :xl="8" class="logo">
					<el-image
					  style="width: 300px; height: 76px"
					  :src="logoSrc"
					  ></el-image>
				</el-col>
				<el-col :xs="0" :sm="8" :md="8" :lg="8" :xl="8"><div class="search">
					  <el-input placeholder="行业、类型、招标标题、新闻标题、新闻详情" v-model="keywords" class="input-with-select" style="border-radius: 5px;">
						<el-button type="primary" slot="append" icon="el-icon-search" style="background-color: #409EFF;color: #fff;height: 40px;width:100px;margin-right:-21px;" class="searchBtn" @click='search'>搜索</el-button>
					  </el-input>
				 </div></el-col>
				<el-col :xs="0" :sm="8" :md="8" :lg="8" :xl="8"><div class="middleRight">
					<el-button @click="handle('/release')">发布招标项目</el-button>
				 </div></el-col>
			</el-row>
		</div>
		<el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :offset="2" class="nav">
			<div class="navs">
				<el-menu
			  :default-active="activeIndex2"
			  class="el-menu-demo"
			  mode="horizontal"
			  background-color="#409EFF"
			  text-color="#fff"
			  active-text-color="#ffd04b">
			  <el-menu-item index="1" class="navitem"><router-link to="/index">首页</router-link></el-menu-item>
			  <el-menu-item index="2" class="navitem"><router-link to="/list">招标公告</router-link></el-menu-item>
			  <el-menu-item index="3" class="navitem"><router-link to="/newslist/id/3">采购中心</router-link></el-menu-item>
			  <el-menu-item index="4" class="navitem"><router-link to="/sandan">散单需求</router-link></el-menu-item>
			  <el-menu-item index="5" class="navitem"><router-link to="/newslist/id/5">招投标常识</router-link></el-menu-item>
			  <el-menu-item index="6" class="navitem"><router-link to="/newslist/id/6">物流常识</router-link></el-menu-item>
			  <el-menu-item index="7" class="navitem"><router-link to="/member">会员频道</router-link></el-menu-item>
			  <el-menu-item index="8" class="navitem"><router-link to="/about">关于我们</router-link></el-menu-item>
			</el-menu>
			</div>
		</el-col>
		<el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
			<div class="banner">
				  <el-carousel :interval="5000" arrow="hover" height="400px">
					<el-carousel-item v-for="item in bannerList" :key="item.Id">
					  <el-image :src="domain + item.image" fit='fill' style='width:100%;height:400px'></el-image>
					</el-carousel-item>
				  </el-carousel>
			</div>
		</el-col>
		<!-- 手机端 -->
		<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			<div class="mobile-top">
				<div class="mobile-logo">
					<el-image
					  style="width: 200px"
					  :src="logoSrc"
					  ></el-image>
				</div>
				<i class="el-icon-phone-outline" style="font-size: 1rem;margin-left: 20px;color: red;"></i><div class="mobile-phone"> {{mobile}}</div>
			</div>
		</el-col>

		<div class="mobile-banner" style="margin:0 -28px">
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
				<el-carousel :interval="5000" height="222px" arrow="never">
					<el-carousel-item v-for="item in mobileBanner" :key="item.Id">
					  <el-image :src="domain + item.image" fit='fill' style='width:100%;height:222px'></el-image>
					</el-carousel-item>
				</el-carousel>
			</el-col>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
		isLogin:false,
		logoSrc:'',
		mobile:'',
		domain:this.$utils.httpUrl,
		userInfo:{},
		bannerList:[],
		mobileBanner:[],
        formInline: {
          username: '',
          password: ''
        },
		keywords:'',
		activeIndex2: '1'
      }
    },
	beforeCreate() {
		if(window.localStorage.getItem("token")){
			this.$axios({
				url:this.$utils.httpApi + 'user/getinfos',
				headers:{
					'token':window.localStorage.getItem("token")
				}
			}).then(res=>{
				this.userInfo = res.data
				this.isLogin = true
			})	
		}
	},
	created() {
		this.$axios({
			url:this.$utils.httpApi + 'index'
		}).then(res=>{
			this.logoSrc = this.$utils.httpUrl + res.data.data.logosrc
			this.mobile = res.data.data.mobile
		})
		this.getBanner()
	},
    methods: {
		search(){
			if(this.keywords != ''){
				this.$router.push('/search/keywords/'+this.keywords)
			}else{
				this.$message({
					message:'请输入搜索关键词！',
					type:'error'
				})
			}

		},
		getBanner(){
			this.$axios({
				url:this.$utils.httpApi + 'index/getBanner'
			}).then(res=>{
				res.data.data.forEach(res=>{
					if(res.type == 0){
						this.bannerList.push(res)
					}else if(res.type ==6){
						this.mobileBanner.push(res)
					}
				})			
			})
		},
		onSubmit() {
			this.$axios({
				method:'post',
				url:this.$utils.httpApi + 'user/login',
				data:this.formInline
			}).then(res=>{
				if(res.data.code == 1){
					window.localStorage.setItem('token',res.data.data.userinfo.token)
					window.location.reload()
					this.isLogin = true
					
				}else{
					this.$message.error(res.data.msg)
					
				}
			})
		},
		handle(url){
			this.$router.push(url)
		},
		loginOut(){
			window.localStorage.removeItem('token')
			this.isLogin = false
			window.location.reload()
		}
    }
  }
  </script>

<style scoped>
	.mobile-top{
		margin-top:-60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.mobile-phone{
		color:red;
		font-size: 0.8rem;
		font-weight: bold;
		margin-top: -5px;
	}
	.top{
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.welcome{
		font-size: 0.8rem;
		color: #909399;
	}
	.topright{
		text-align: left!important;
		color:#909399;
		height:36px;
		font-size: 0.8rem;
	}
	.topright a{
		text-decoration: none;
		color:#909399;
/* 		border-left: 1px solid #909399;
		padding-left: 10px; */
	}
	.toprightfirst{
		border-left: 0!important;
	}
	.topright a:hover{
		color:#409EFF;
	}
	.form{
		height: 36px;
	}
	.input{
		height: 30px;
	}
	.el-col {
	border-radius: 4px;
	text-align: center;
	}
	.grid-content {
	border-radius: 4px;
	min-height: 45px;
	line-height: 45px;
	text-align: center;
	}
	.middle{
		margin-top: 20px;
		vertical-align: middle;
		height: 50px;
	}
	.logo{
		
	}
	.input-with-select{
		border: #409EFF 1px solid;
	}
	.searchBtn{
		background-color: #409EFF;
		color: #fff;
	}
	.search,.middleRight{
		height:80px;
		line-height:
		80px;
		vertical-align: middle;
	}
	.nav{
		margin-top: 20px;
	}
	.navitem{
		width:12.5%;
	}
	.navitem a{
		font-size: 1.2rem;
		text-decoration: none;
		display: block;
		width:100%;
		height:100%;
	}
	.el-carousel__item h3 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 350px;
	margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
	background-color: #d3dce6;
	}
</style>